import {Button, Card, Space, Steps} from '@baidu/qianfan-antd-kit';
import styled from 'styled-components';

export const COLOR_TEXT_GREY = '#84868C';
export const COLOR_TEXT_DESCRIPTION = '#5C5F66';
export const COLOR_TEXT_TERTIARY = '#818999';
export const COLOR_LIGHT_GREY = '#D4D6D9';
export const COLOR_TEXT_TIP = '#84868C';
export const COLOR_PRIMARY = '#2450FF';
export const COLOR_HOVER_PRIMARY = '#4d76ff';
export const COLOR_WARNING = '#FF9326';
export const COLOR_DANGER = '#FA423C';
export const COLOR_HIGHT = '#8C66FF';
export const COLOR_TIP_GREY = '#495366';
export const COLOR_TEXT_SECONDARY = '#495366';
export const COMPONENT_COLOR_GRAY_B1 = '#F7F9FC';

export const SCContainer = styled.div`
    height: ${(props: any) => {
        if (props.$height !== undefined) {
            return props.$height;
        }
        return props.$iframe
            ? 'auto' : '100%';
    }};
    background: ${(props: any) => {
        return props.$iframe
            ? '#fff' : 'none';
    }};
    padding-bottom: ${(props: any) => {
        return props.$iframe
            ? 0 : '1.6rem';
    }};
    @media (max-width: 600px) {
        padding-bottom: 6rem;
    }
`;

export const SCBgGrey = styled.div`
    background-color: #f4f4f4;
    padding: 12px;
    height: 100vh;
    padding-bottom: 10rem;
    overflow-y: scroll;
    .adm-list {
        background-color: #f4f4f4;
    }
`;

export const SCDanger = styled.span`
    color: ${COLOR_DANGER};
`;

export const SCWarning = styled.span`
    color: ${COLOR_WARNING};
`;

export const SCPrimary = styled.span`
    color: #000;
`;

export const SCFormTip = styled.div`
    color: ${COLOR_TEXT_TERTIARY};
    line-height: 16px;
    font-size: 1.2rem;
    margin: 0 0 0.8rem 0;
    a {
        margin-left: 0.8rem;
    }
`;

export const SCFormAlert = styled.div`
    color: ${COLOR_TEXT_TERTIARY};
    line-height: 16px;
    font-size: 1.2rem;
`;

export const SCAgreementTip = styled.div`
    font-size: 1.3rem;
    color: ${COLOR_TEXT_SECONDARY};
`;

export const SCBottomFix = styled.div`
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 1.6rem;
    background: #fff;
    z-index: 10;
`;

export const SCBottomFixCenter = styled(SCBottomFix)`
    padding: 1.6rem 0 2.4rem;
    display: flex;
    justify-content: center;
`;

export const SCFooterButton = styled(Button)`
    min-width: 40vw;
`;

export const SCFooter = styled(Space)`
    display: flex;
    justify-content: start;
    margin-top: 1.6rem;
    @media (max-width: 600px) {
        justify-content: center;
    }
`;

export const SCFooterContainer = styled.div`
    /* padding-bottom: 7rem; */
`;

export const SCCenterTitle = styled.h2`
    font-family: PingFangSC-Medium;
    font-size: 2rem;
    color: #151b26;
    line-height: 3rem;
    font-weight: 500;
`;

export const SCCenterIframeTitle = styled.h2`
    font-family: PingFangSC-Medium;
    font-size: 2rem;
    color: #000;
    line-height: 3rem;
    font-weight: 500;
`;

export const SCLegendTitle = styled.div`
    border-left: 4px solid ${COLOR_PRIMARY};
    border-radius: 2px 0 0 2px;
    padding-left: 0.8rem;
    font-size: 1.6rem;
    font-weight: 500;
    line-height: 1.6rem;
`;

export const SCIframeTitle = styled.div`
    font-size: ${(props: any) => (props.$fontSize === undefined ? '2rem' : props.$fontSize)};
    font-weight: 500;
    line-height: 3.6rem;
    text-align: center;
    cursor: pointer;
    color: ${(props: any) => props.$color || 'inherit'};
    ${(props: any) => props.$hoverColor && `
        &:hover {
            color: ${props.$hoverColor} !important;
        }
    `}
`;

export const FormCard = styled(Card)``;

export const SCSelectItem = styled.div`
    font-size: 1.4rem;
    border-bottom: 1px solid #d6d6d6;
`;

export const SCCenterLoading = styled.div`
    width: inherit;
    text-align: center;
`;

export const SCPicContainer = styled.div`
    padding: 0.8rem;
    width: fit-content;
`;

export const SCUploadBtn = styled.div`
    padding: 0.8rem;
    width: 8rem;
    height: 8rem;
    background: #f5f5f5;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    color: ${COLOR_TEXT_DESCRIPTION};
`;

export const SCLineText = styled.span`
    // 移动端响应式兼容
    @media (max-width: 600px) {
        line-height: 3rem;
        font-size: 1.4rem;
    }
`;

export const SCSteps = styled(Steps)`
    margin: 2.4rem auto;
    width: 80%;
`;
